import { LoadingButton } from '@mui/lab';
import { Box, Button, Card, Grid, MenuItem, Select, Stack, Typography } from '@mui/material';
import React, { useState } from 'react'
import { useRef } from 'react';
import { RHFSelect } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import EmailTemplateInterview from 'src/sections/interview/email-template-interview';



const EmailTemplate = ({ heading, onBackClick, type, methods, validTillOptions, isSubmitting, items, inputFileType }) => {
    const [showEmailPreview, setShowEmailPreview] = useState(false);
    const emailPreviewButtonRef = useRef(null);

    return (
        <Grid sx={{ width: '80%' }} xs={12}>
            <Stack
                spacing={1.5}
                direction="row"
                alignItems="center"
                sx={{
                    mb: { xs: 3, md: 5 },
                }}
            >
                <Box sx={{ flexGrow: 1 }}>
                    <Box sx={{ mb: '1rem' }}>
                        <Typography variant="h5">{heading}</Typography>
                    </Box>
                    <Box>
                        <Button
                            onClick={() => onBackClick(false)}
                            startIcon={<Iconify icon="eva:arrow-ios-back-fill" width={16} />}
                        >
                            Back
                        </Button>
                    </Box>
                </Box>
            </Stack>

            <Card sx={{ minHeight: '50vh' }}>
                <Stack spacing={3} sx={{ p: 3, minHeight: '50vh' }}>
                    <Stack
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '2rem',
                            alignItems: 'center',
                        }}
                    >
                        <Typography variant="h6">Interview valid for next</Typography>

                        <RHFSelect
                            name="valid_for"
                            size="small"
                            sx={{
                                width: '10rem',
                                maxWidth: '10rem',
                            }}
                            MenuProps={{
                                PaperProps: {
                                    style: {
                                        maxHeight: 200, // Adjust this value to control the height
                                    },
                                },
                            }}
                        >
                            {validTillOptions?.map(item => (
                                <MenuItem key={item} value={item}>
                                    {item}
                                </MenuItem>
                            ))}
                        </RHFSelect>
                    </Stack>

                    <Stack
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '2rem',
                            alignItems: 'center',
                        }}
                    >
                        <Typography variant="h6">Send email to candidates</Typography>

                        <RHFSelect
                            name="sendEmail"
                            size="small"
                            sx={{
                                width: '8rem',
                                maxWidth: '8rem',
                            }}
                        >
                            <MenuItem key="Yes" value={true}>
                                Yes
                            </MenuItem>
                            <MenuItem key="No" value={false}>
                                No
                            </MenuItem>
                        </RHFSelect>
                    </Stack>

                    {methods.getValues().sendEmail && (
                        <EmailTemplateInterview
                            setShowEmailPreview={setShowEmailPreview}
                            emailPreviewButtonRef={emailPreviewButtonRef}
                            open={showEmailPreview}
                            handleClose={() => setShowEmailPreview(false)}
                            valid_for={methods.getValues().valid_for}
                        />
                    )}

                    <LoadingButton
                        type="submit"
                        variant="contained"
                        size="large"
                        disabled={type === 'bulk' && items.length === 0}
                        name="generateURL"
                        loading={isSubmitting}
                        sx={{ margin: 'auto auto', mb: 3 }}
                    >
                        {type === 'single' && 'Add candidate in workflow'}
                        {type === 'bulk' && `Add ${inputFileType === 'pdf' ? ` ${items.length}` : ''} candidates in workflow`}
                        {type === 'singleShortlist' && 'Add candidate in workflow'}
                        {type === 'bulkShortlist' && `Add ${items.length} candidates in workflow`}
                    </LoadingButton>
                </Stack>
            </Card>
        </Grid>
    )
}

export default EmailTemplate;